class Com{

    constructor(apiService=null){
        this.obj_name = 'com'
        this.apiService = apiService != null ? apiService : null; // 將 ApiService 實例儲存為屬性
    }
    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            { condition: formData.company_name.trim() === '', message: '請輸入廠商名稱' },
            { condition: formData.serial_no.trim() === '' , message: '請輸入廠商代碼' },
            { condition: formData.gui_no.trim() === '' , message: '請輸入統一編號' },
            { condition: formData.contact_name.trim() === '' , message: '請輸入聯絡人' },
            { condition: formData.contact_phone.trim() === '' , message: '請輸入聯絡資訊' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }   

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    // 送出前檢查表單填寫格式
    checkAccountCreateFromModel(formData) {
        const validations = [
            { condition: formData.email.trim() === '', message: '請輸入Email做為帳號' },
            { condition: !this.isValidEmail(formData.email.trim()), message: '請輸入格式Email' },
            { condition: formData.password.trim() === '' , message: '請輸入密碼' },
            { condition: formData.rePassword.trim() === '' , message: '請再次輸入密碼' },
            { condition: formData.rePassword.trim() !== formData.password.trim() , message: '密碼與再次輸入密碼需相符' },
            { condition: formData.name.trim() === '' , message: '請輸入帳號姓名' },
            { condition: formData.department_sn.trim() === '' , message: '請選擇所屬單位' },
            { condition: formData.role_id === -1 , message: '請選擇角色' },
            { condition: formData.img_src === '' , message: '請上傳你的頭像' },
            { condition: formData.is_enable_controlledDrugs === true && formData.controlledDrugs_no == '' , message: '請輸入管制藥證' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }   
    
    //廠商 | 101新增廠商
    async addCompany(parameter, progressEvent = null){
        return this.callApi('post', 'addCompany', parameter , progressEvent);
    }
    //廠商 | 102更新廠商
    async updCompany(parameter, progressEvent = null){
        return this.callApi('post', 'updCompany', parameter , progressEvent);
    }
    //廠商 | 103搜尋廠商列表
    async getCompanyByKeywordWithPage(parameter=null){
        return this.callApi('get', 'getCompanyByKeywordWithPage', parameter);
    }
    //廠商 | 104取得廠商詳細資料
    async getCompanyDetailByCompanyId(parameter=null){
        return this.callApi('get', 'getCompanyDetailByCompanyId', parameter);
    }
}

export default Com;